export const numberWithCommas = (x: number | string) => {
  x = Number(x);
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
